<mat-drawer-container>
  <mat-drawer-content [style.--heightOffset]="heightOffset()">
    @switch (currentLayout()) {
      @case ('mobile') {
        <div class="three-panel-page-container">
          <mat-tab-group
            mat-stretch-tabs="true"
            class="mobile-tab-group"
            [ngClass]="{ 'no-panel-padding': fullPanelConfig().noMobilePadding }"
          >
            <mat-tab label="{{ leftPanelConfig().title }}">
              <ng-container [ngTemplateOutlet]="leftPanelConfig().template"></ng-container>
            </mat-tab>
            <mat-tab label="{{ centerPanelConfig().title }}">
              <ng-container [ngTemplateOutlet]="centerPanelConfig().template"></ng-container>
            </mat-tab>
            @if (showRightPanel()) {
              <mat-tab label="{{ rightPanelConfig().title }}">
                <ng-container [ngTemplateOutlet]="rightPanelConfig().template"></ng-container>
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      }
      @case ('tablet') {
        <div class="three-panel-page-container">
          <div
            class="panel left-panel"
            [ngClass]="{
              'no-panel-padding': leftPanelConfig().noDefaultPadding,
              'no-border': leftPanelConfig().noBorder,
            }"
          >
            <ng-container [ngTemplateOutlet]="leftPanelConfig().template"></ng-container>
          </div>
          <mat-tab-group class="tablet-tab-group">
            <mat-tab label="{{ centerPanelConfig().title }}">
              <ng-container [ngTemplateOutlet]="centerPanelConfig().template"></ng-container>
            </mat-tab>
            @if (showRightPanel()) {
              <mat-tab label="{{ rightPanelConfig().title }}">
                <ng-container [ngTemplateOutlet]="rightPanelConfig().template"></ng-container>
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      }
      @case ('desktop') {
        <div class="three-panel-page-container">
          <div
            class="panel left-panel"
            [ngClass]="{
              'no-panel-padding': leftPanelConfig().noDefaultPadding,
              'no-border': leftPanelConfig().noBorder,
            }"
            [ngStyle]="leftPanelConfig().desktopStyleOverrides"
          >
            <ng-container [ngTemplateOutlet]="leftPanelConfig().template"></ng-container>
          </div>
          <div
            class="panel center-panel"
            [ngClass]="{
              'no-panel-padding': centerPanelConfig().noDefaultPadding,
              'no-border': centerPanelConfig().noBorder,
            }"
            [ngStyle]="centerPanelConfig().desktopStyleOverrides"
          >
            <ng-container [ngTemplateOutlet]="centerPanelConfig().template"></ng-container>
          </div>
          @if (showRightPanel()) {
            <div
              class="panel right-panel"
              [ngClass]="{
                'no-panel-padding': rightPanelConfig().noDefaultPadding,
                'no-border': rightPanelConfig().noBorder,
              }"
              [ngStyle]="rightPanelConfig().desktopStyleOverrides"
            >
              <ng-container [ngTemplateOutlet]="rightPanelConfig().template"></ng-container>
            </div>
          }
        </div>
      }
    }
  </mat-drawer-content>
</mat-drawer-container>
